import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import content from "../../includes/content";

const PageOne = ({ data, setPageOne, setPageTwo }) => {
  return (
    <Container className="main fadeIn">
      <Row>
        <Col className="text-space order-2 order-lg-1" lg={6}>
          <h3 className="d-flex justify-content-center justify-content-lg-start align-items-center">
            {content.mainHeadline}
          </h3>
          <h1 className="d-flex justify-content-center justify-content-lg-start align-items-center cert">
            CERTIFICATE
          </h1>
          <div className="centering">
            <p className="mt-3 mt-lg-5 mb-3">
              <span>Dear {`${data.firstName},`}</span>
            </p>
          </div>
          <div className="centering">
            <p>{content.pageOneText}</p>
          </div>
          <div>
            <button
              onClick={() => {
                setPageOne(false);
                setPageTwo(true);
              }}
              type="button"
              className="firstButton"
              disabled={!data}
            >
              Click Here to View Your Certificate
            </button>
          </div>
          <div className="regards bottom-margin">
            <p>With regards:</p>
            <p>
              <span className="pavan"> Pavan Agarwal</span>
              <br className="line-break" /> <span className="line">|</span> CEO
            </p>
            <p>Sun West Mortgage Company, Inc. (NMLS ID: 3277)</p>
            <a href="https://www.swmc.com/" target="_blank" rel="noreferrer">
              www.swmc.com
            </a>
          </div>
        </Col>
        <Col
          className="right-col order-1 order-lg-2 d-flex m-0 p-0 justify-content-center align-items-start"
          lg={6}
        >
          <Image className="hide-img" fluid src={content.pageOneMobileImage} />
        </Col>
      </Row>
    </Container>
  );
};
export default PageOne;
